import { styled } from 'linaria/react'

const AvoidWrap = styled.span`
	display: inline-block;
`

export default AvoidWrap
